import React from 'react';
import Axios from 'axios';
import moment from 'moment';

class NewsletterMembers extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			members: []
		};
	
		this.loadNewsletterMembersFromApi = this.loadNewsletterMembersFromApi.bind(this);
		this.createMemberRow = this.createMemberRow.bind(this);
		this.handleClickDelete = this.handleClickDelete.bind(this);
	}

	componentDidMount() {
		this.loadNewsletterMembersFromApi();
	}

	loadNewsletterMembersFromApi() {
		var _this = this;
		Axios.get('/api/newsletterMembers/').then(function (response) {
			_this.setState({members: response.data});
		});
	}

	render() {
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Membres de l'infolettre</h5>
				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>
						Membres de l'infolettre
					</div>

					<div className="card-block">
					<table className="table table-striped table-hover">
					  <tbody>
						<tr>
							<th>ID</th>
							<th>Nom</th>
							<th>Courriel</th>
							<th>Msg Texte</th>
							<th>Ligues</th>
							<th>Inscription</th>
							<th> </th>
						</tr>
						{this.state.members.map(this.createMemberRow)}
					</tbody>
					</table>
					</div>
				</div>
			</div>
			</div>
		);
	}
	
	createMemberRow(member) {
		return (
			<tr key={member._id}>
				<td>{member._id}</td>
				<td>{member.name}</td>
				<td>{member.email}</td>
				<td>{member.textmsg}</td>
				<td>{member.leagues}</td>
				<td>{moment(member.inscriptionDate).utc().format("YYYY-MM-DD")}</td>
				<td><input id={'del.' + member._id} name={member.name} type="button" onClick={this.handleClickDelete} value="Supprimer"/></td>
			</tr>
		);
	}

	handleClickDelete(event) {
		var memberId = event.target.id.split('.')[1];
		var memberName = event.target.name;
		var _this = this;

		if(window.confirm('Retirer le membre de l\'infolettre: ' + memberName + '\nCliquer sur OK pour confirmer')) {
			Axios.delete('/api/newsletterMembers/' + memberId).then(function(response) {
				_this.loadNewsletterMembersFromApi();
			});
		}
	}

}

export default NewsletterMembers;